var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "button-group" },
    [
      _vm.label
        ? _c("span", { staticClass: "label" }, [
            _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.items, function(item) {
        return _c("button-fill", {
          key: item,
          attrs: {
            active: item === _vm.value,
            label: item,
            uppercase: _vm.uppercase
          },
          on: {
            click: function() {
              return _vm.onClick(item)
            }
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26d4be72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d4be72","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/button-group.vue
// module id = 1256
// module chunks = 0